var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeorgia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0225C24.8366 32.0225 32 24.859 32 16.0225C32 7.1859 24.8366 0.0224609 16 0.0224609C7.16344 0.0224609 0 7.1859 0 16.0225C0 24.859 7.16344 32.0225 16 32.0225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9355H18.0871H18.087V0.157898C17.4038 0.0689609 16.7073 0.0224609 16 0.0224609C15.2927 0.0224609 14.5962 0.0689609 13.9131 0.157898V13.9354V13.9355H0.135438C0.0465 14.6186 0 15.3151 0 16.0225C0 16.7299 0.0465 17.4263 0.135438 18.1094H13.9129H13.913V31.887C14.5962 31.976 15.2927 32.0225 16 32.0225C16.7073 32.0225 17.4038 31.976 18.0869 31.887V18.1095V18.1095H31.8646C31.9535 17.4263 32 16.7299 32 16.0225C32 15.3151 31.9535 14.6186 31.8646 13.9355V13.9355Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73912 7.67468V5.58768H7.65219V7.67468H5.56519V9.76161H7.65219V11.8486H9.73912V9.76161H11.8261V7.67468H9.73912Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3476 7.67468V5.58768H22.2606V7.67468H20.1737V9.76161H22.2606V11.8486H24.3476V9.76161H26.4346V7.67468H24.3476Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73912 22.2831V20.1962H7.65219V22.2831H5.56519V24.3701H7.65219V26.4571H9.73912V24.3701H11.8261V22.2831H9.73912Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3476 22.2831V20.1962H22.2606V22.2831H20.1737V24.3701H22.2606V26.4571H24.3476V24.3701H26.4346V22.2831H24.3476Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgia);
export default __webpack_public_path__ + "static/media/georgia.b16e7d42.svg";
export { ForwardRef as ReactComponent };